import { render, staticRenderFns } from "./UserTemplate.vue?vue&type=template&id=c090a858&"
import script from "./UserTemplate.vue?vue&type=script&lang=js&"
export * from "./UserTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports